import { useEffect, useState } from "react";

import { Box, Grid, Stack, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import { FingerprintOutlined, PersonOutlined } from "@mui/icons-material";

import CardBoxExtended from "../../common/components/mui-extended/CardBoxExtended";
import userService from "../../services/userService";
import useUserContext from "../../hooks/useUserContext";
import { ProfileDto } from "../../interfaces/ProfileDto";
import { dateToStringShort } from "../../common/utils/dateTime";

export default function Profile() {
  const { userId } = useUserContext();
  const [profileData, setProfileData] = useState<ProfileDto>();

  useEffect(() => {
    (async () => {
      await userService.getProfileDataAsync(userId).then(({ data: profileData }) => {
        setProfileData(profileData);
      });
    })();
  }, []);

  return (
    <Stack spacing={3}>
      <Typography variant="h5">Личен профил</Typography>
      <Box>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <CardBoxExtended icon={<PersonOutlined />} title="Лични данни">
              <Table sx={{ mt: "10px", mb: "-15px" }}>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <Typography>Потребител</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        <strong>{profileData?.username}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>
                      <Typography>Банка</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        <strong>{profileData?.bankName}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>
                      <Typography>Клон на банка</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        <strong>{profileData?.bankBranchName}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </CardBoxExtended>
          </Grid>

          <Grid item xs={12} lg={6}>
            <CardBoxExtended icon={<FingerprintOutlined />} title="Данни за подпис">
              <Table sx={{ mt: "10px", mb: "-15px" }}>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <Typography>Издаден на</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        <strong>{profileData?.signatureData?.issuedTo}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>
                      <Typography>Издаден от</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        <strong>{profileData?.signatureData?.issuedBy}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>
                      <Typography>Валиден от</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        <strong>{dateToStringShort(profileData?.signatureData?.validFrom)}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>
                      <Typography>Валиден до</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        <strong>{dateToStringShort(profileData?.signatureData?.validTo)}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell sx={{ borderBottom: "none" }}>
                      <Typography>Сериен номер</Typography>
                    </TableCell>
                    <TableCell sx={{ borderBottom: "none" }}>
                      <Typography>
                        <strong>{profileData?.signatureData?.serialNumber}</strong>
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </CardBoxExtended>
          </Grid>
        </Grid>
      </Box>
    </Stack>
  );
}
